<template>
  <div>
    <el-dialog lock-scroll
               :modal-append-to-body="false"
               :append-to-body="true"
               :title="$t('从地址簿选择')"
               custom-class="jms-dialog MTAuto"
               :close-on-click-modal="false"
               :visible.sync="visible"
               @close="close"
               width="900px">
      <div class="overflow">
        <div class="search">
          <el-input v-model="searchParams.keyword" :placeholder="$t('姓名/联系电话/地址')" class="input" @keyup.enter.native="search">
          </el-input>
          <el-button type="primary" icon="iconfont iconchaxun" class="h32" @click="search">{{ $t('查询') }}</el-button>
        </div>
        <JmsTable :option="listOpt"
                  :data="tableList"
                  :page="page"
                  :table-loading="loading"
                  @size-change="sizeChange"
                  @select-change="selectionChange"
                  @row-click="currentRowChange"
                  @current-change="currentChange">
          <template v-slot:singleSelect="{row}">
            <div v-if="currentAddress.id === row.id"><i class="iconfont iconchenggong"></i></div>
          </template>
        </JmsTable>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" style="width:125px;" :loading="isLoading" :disabled="!currentAddress.cityId" @click="confirm" class="h40 h104">{{ $t('确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JmsTable from '@/components/jms-widget/jms-table'
import mixin from '@/mixins/mixin.js'
import { mapGetters } from 'vuex'
import { addressPage, checkArea } from '@/api/module/customer'

export default {
  name: 'AddressBookDialog',
  props: {
    value: {},
    selectType: {
      type: Number,
      default: 1,
    },
  },
  components: {
    JmsTable,
  },
  mixins: [mixin],
  data() {
    return {
      COM_HTTP: { reqList: addressPage },
      visible: false,
      page: {
        current: 1,
        size: 20,
        total: 0,
      },
      searchParams: {
        type: this.selectType,
        keyword: '', // 关键字
      },
      loading: false,
      currentAddress: {},
      // 21117,多国合一，根据用户的国家code，行政区域的label有变化，下面是沙特(原来)的行政区划
      provinceName: this.$lang('省份'),
      cityName: this.$lang('城市'),
      isLoading: false
    }
  },
  computed: {
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    ...mapGetters({
      user: 'user',
    }),
    listOpt() {
      const that = this
      return {
        border: true,
        selection: false,
        menu: false,
        tableHeight: 490,
        currentRow: true,
        //  搜索框和表格列及其字段
        column: [
          { label: this.$lang('姓名'), prop: 'name' },
          { label: this.$lang('联系电话') }, //  扫描员prop: 'mobile', width: 120,},
          { label: this.$lang('备用电话') }, //  扫描员prop: 'reserveMobile',width: 120,},
          { label: that.provinceName, prop: 'provinceName' },
          { label: that.cityName, prop: 'cityName' },
          { label: this.$lang('街道'), prop: 'areaName', width: 300 },
          { prop: this.$lang('singleSelect'), width: 100, slot: true },
        ]
      }
    }
  },
  watch: {
    countryCode(val) {
      if (val === 'UAE') {
        // 阿联酋的用户行政区域要变
        this.provinceName = this.$lang('酋长国')
        this.cityName = this.$lang('区域')
      }
    },
    value: {
      handler(val) {
        this.visible = val
      },
      deep: true,
    }
  },
  methods: {
    getParams() {
      const { type, keyword } = this.searchParams
      return {
        type: type,
        keyword: keyword
      }
    },
    // 搜索
    search() {
      this.searchFun(1)// 列表带分页
    },
    updateBtnStatus(addressData) {
      if (addressData) {
        this.currentAddress = addressData
      } else {
        this.currentAddress = {}
      }
    },
    confirm() {
      this.checkArea(this.currentAddress)
    },
    close() { // 关 闭
      this.visible = false
      this.currentAddress = {}
      this.$emit('input', this.visible)
      this.$emit('change', this.visible)
    },
    // 单选-选中
    currentRowChange(val) {
      if (val) {
        this.disabled = false
        this.currentAddress = val
      }
    },
    // 检查省市区地址
    async checkArea(obj) {
      const { provinceId, cityId, areaId } = obj
      this.isLoading = true
      const { code, data } = await checkArea({ provinceId, cityId, areaId })
      this.isLoading = false
      if (code === 1 && data) {
        this.$emit('single-row-select', this.currentAddress, this.selectType)
        this.visible = false
      } else {
        const msg = this.selectType === 1 ? this.$lang('该寄件地址尚未开放，敬请期待') : this.$lang('该收件地址尚未开放，敬请期待')
        this.$message.warning(this.$lang(msg))
      }
    },
    async addressPage(reqData) { // 列表带分页
      const { code, data, msg } = await addressPage(reqData)
      if (code === 1) {
        this.tableList = data.records
        this.page.total = data.total
      } else {
        this.$message.error(msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search {
  height: 32px;
  line-height: 32px;
  margin-bottom: 16px;

  .input {
    width: 240px !important;
    margin-right: 24px;
  }

  .icon-search {
    display: inline-block;
    width: 20px;
    height: 32px;
    line-height: 32px;
  }

  .add {
    color: #e60012;;

    .iconxinzeng {
      margin-right: 4px;
    }
  }
}

.form-title {
  font-size: 16px;
  font-weight: bold;

  i {
    margin-right: 7px;
  }
}

.iconchaxun:hover {
  color: #e60012;
}
</style>
<style lang="scss">
.MTAuto {
  .el-table {
    max-height: 430px;
  }
}
</style>
